(function () {
  var TRACKING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'device',
    'network',
    'placement',
    'adposition',
    'channel',
    'source',
  ];
  var STORAGE_KEY = 'lb_contact_tracking';
  var COOKIE_DAYS = 30;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value) {
    if (!value) return;
    var maxAge = COOKIE_DAYS * 24 * 60 * 60;
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getStoredTracking() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch (err) {
      return {};
    }
  }

  function saveStoredTracking(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (err) {
      /* unavailable */
    }
  }

  function captureTrackingFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var stored = getStoredTracking();
    var updated = false;

    TRACKING_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        stored[key] = value;
        writeCookie(key, value);
        updated = true;
      }
    });

    if (updated) {
      saveStoredTracking(stored);
    }

    return stored;
  }

  function getTrackingValue(key, stored) {
    var params = new URLSearchParams(window.location.search);
    return params.get(key) || stored[key] || readCookie(key) || '';
  }

  function applyTrackingToForm(form) {
    if (!form) return;

    var stored = captureTrackingFromUrl();

    TRACKING_KEYS.forEach(function (key) {
      var value = getTrackingValue(key, stored);
      var input = form.elements[key];
      if (input && !input.disabled) {
        input.value = value;
      }
    });

    var landingInput = form.elements.landing_page;
    if (landingInput) {
      landingInput.value = window.location.href;
    }
  }

  function buildFormData(form) {
    var stored = captureTrackingFromUrl();
    var data = new FormData();

    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if (el.type === 'submit' || el.type === 'button') return;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;

      data.append(el.name, el.value);
    });

    TRACKING_KEYS.forEach(function (key) {
      data.set(key, getTrackingValue(key, stored));
    });

    data.set('landing_page', window.location.href);

    return data;
  }

  function refreshAllContactForms() {
    document.querySelectorAll('form#lb-contact-form').forEach(applyTrackingToForm);
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || form.id !== 'lb-contact-form') return;

    event.preventDefault();
    event.stopPropagation();

    applyTrackingToForm(form);

    var success = form.querySelector('#lb-form-success');
    var data = buildFormData(form);

    fetch(form.action, {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) return;

      form.querySelectorAll('.lb-form__field, .lb-form__footer').forEach(function (el) {
        el.style.display = 'none';
      });

      if (success) {
        success.style.display = 'block';
      }
    });
  }

  function init() {
    refreshAllContactForms();
    document.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', refreshAllContactForms);
})();
